import type { RouteObject } from "react-router-dom";
import { useSearchParams, useParams } from "react-router-dom";
import { SellerCreatePage } from "./pages/SellerCreatePage";
import { SellerDetailPage } from "./pages/SellerDetailPage";
import { SellersPage } from "./pages/SellersPage";
import { RestaurantCreatePage } from "./pages/RestaurantCreatePage";
import { useLocale } from "@admin/app/locale";

function toNumber(value: string | null, fallback: number) {
  const parsed = value ? Number(value) : Number.NaN;
  return Number.isFinite(parsed) ? parsed : fallback;
}

function AdminSellersRoute() {
  const locale = useLocale();
  const [searchParams] = useSearchParams();

  return (
    <SellersPage
      locale={locale}
      limit={toNumber(searchParams.get("limit"), 20)}
      offset={toNumber(searchParams.get("offset"), 0)}
    />
  );
}

function AdminSellerCreateRoute() {
  const locale = useLocale();
  const [searchParams] = useSearchParams();
  return (
    <SellerCreatePage
      locale={locale}
      limit={toNumber(searchParams.get("limit"), 20)}
      offset={toNumber(searchParams.get("offset"), 0)}
    />
  );
}

function AdminSellerDetailRoute() {
  const locale = useLocale();
  const { id = "" } = useParams();
  return <SellerDetailPage locale={locale} sellerId={id} />;
}

function AdminRestaurantCreateRoute() {
  const locale = useLocale();
  return <RestaurantCreatePage locale={locale} />;
}

export const sellerRoutes: RouteObject[] = [
  {
    path: "restaurants/new",
    element: <AdminRestaurantCreateRoute />,
  },
  {
    path: "sellers",
    element: <AdminSellersRoute />,
  },
  {
    path: "sellers/new",
    element: <AdminSellerCreateRoute />,
  },
  {
    path: "sellers/:id",
    element: <AdminSellerDetailRoute />,
  },
];
